export default __webpack_public_path__ + "static/media/icon-order-adjustment.193fa762.svg";